import { Component, Mixins } from 'vue-property-decorator';
import InfoBlock from '@/components/parts/catalog/card/components/block';
import InfoDescription from '@/components/page/organization/description';
import PageInfo from '@/components/page/organization/info';
import CardMixin from '../common';

@Component({
  components: {
    InfoBlock,
    InfoDescription,
    PageInfo,
  },
})
export default class PageActivityCardInfo extends Mixins(CardMixin) {
  // Computed
  get blocks() {
    const {
      conditions,
      cost,
      duration,
      expectedResults,
      materialBase,
      plan,
      targets,
      contacts,
    } = this.activity;
    return [
      {
        icon: 'plan',
        title: 'План',
        text: plan,
      },
      {
        icon: 'target',
        title: 'Цели',
        text: targets,
      },
      {
        icon: 'result',
        title: 'Ожидаемые результаты',
        text: expectedResults,
      },
      {
        icon: 'conditions',
        title: 'Условия',
        text: conditions,
      },
      {
        icon: 'contacts',
        title: 'Контактные лица',
        text: contacts,
      },
      {
        icon: 'exercise',
        title: 'Длительность',
        text: duration,
      },
      {
        icon: 'price',
        title: 'Стоимость',
        text: cost,
      },
      {
        icon: 'base',
        title: 'Материально-техническая база',
        text: materialBase,
      },
    ];
  }

  get hasContent() {
    return !!this.html;
  }

  get html() {
    return this.activity.description;
  }
}



// WEBPACK FOOTER //
// ./src/pages/activities/card/info/script.ts